import { getFetchHeaders } from '../getFetchHeaders';
import { getFetchResponseData } from '../getFetchResponseData';
import * as types from './types';

const API_BASE = '/api/notifications';

export const actionCreators = {
  /* ===============================
     GET ACTIVE NOTIFICATIONS
     =============================== */
  getActiveNotifications: () => {
    return async (dispatch) => {
      dispatch({ type: types.GET_ACTIVE_NOTIFICATIONS_REQUEST });

      try {
        const headers = await getFetchHeaders();
        const response = await fetch(`${API_BASE}/active`, {
          method: 'GET',
          headers,
        });

        const data = await getFetchResponseData(response);

        dispatch({
          type: types.GET_ACTIVE_NOTIFICATIONS_SUCCESS,
          payload: data,
        });
      } catch (err) {
        dispatch({
          type: types.GET_ACTIVE_NOTIFICATIONS_FAILURE,
          error:
            err.message || 'Failed to fetch active notifications.',
        });
        throw err;
      }
    };
  },

  /* ===============================
     CREATE
     =============================== */
  createNotification: (request) => {
    return async (dispatch) => {
      dispatch({ type: types.CREATE_NOTIFICATION_REQUEST });

      try {
        const headers = await getFetchHeaders();
        const response = await fetch(`${API_BASE}/create`, {
          method: 'POST',
          headers,
          body: JSON.stringify(request),
        });

        const data = await getFetchResponseData(response);

        dispatch({
          type: types.CREATE_NOTIFICATION_SUCCESS,
          payload: data,
        });

        return data;
      } catch (err) {
        dispatch({
          type: types.CREATE_NOTIFICATION_FAILURE,
          error:
            err.message || 'Create notification failed.',
        });
        throw err;
      }
    };
  },

  /* ===============================
     UPDATE
     =============================== */
  updateNotification: (request) => {
    return async (dispatch) => {
      dispatch({ type: types.UPDATE_NOTIFICATION_REQUEST });

      try {
        const headers = await getFetchHeaders();
        const response = await fetch(`${API_BASE}/update`, {
          method: 'PUT',
          headers,
          body: JSON.stringify(request),
        });

        await getFetchResponseData(response);

        dispatch({
          type: types.UPDATE_NOTIFICATION_SUCCESS,
        });
      } catch (err) {
        dispatch({
          type: types.UPDATE_NOTIFICATION_FAILURE,
          error:
            err.message || 'Update notification failed.',
        });
        throw err;
      }
    };
  },

  /* ===============================
     ENABLE / DISABLE
     =============================== */
  enableNotification: (id, request) => {
    return async (dispatch) => {
      dispatch({ type: types.ENABLE_NOTIFICATION_REQUEST });

      try {
        const headers = await getFetchHeaders();
        const response = await fetch(`${API_BASE}/${id}/enable`, {
          method: 'POST',
          headers,
          body: JSON.stringify(request),
        });

        await getFetchResponseData(response);

        dispatch({
          type: types.ENABLE_NOTIFICATION_SUCCESS,
        });
      } catch (err) {
        dispatch({
          type: types.ENABLE_NOTIFICATION_FAILURE,
          error:
            err.message || 'Enable notification failed.',
        });
        throw err;
      }
    };
  },

  disableNotification: (id, request) => {
    return async (dispatch) => {
      dispatch({ type: types.DISABLE_NOTIFICATION_REQUEST });

      try {
        const headers = await getFetchHeaders();
        const response = await fetch(`${API_BASE}/${id}/disable`, {
          method: 'POST',
          headers,
          body: JSON.stringify(request),
        });

        await getFetchResponseData(response);

        dispatch({
          type: types.DISABLE_NOTIFICATION_SUCCESS,
        });
      } catch (err) {
        dispatch({
          type: types.DISABLE_NOTIFICATION_FAILURE,
          error:
            err.message || 'Disable notification failed.',
        });
        throw err;
      }
    };
  },

  /* ===============================
     DELETE
     =============================== */
  deleteNotification: (id) => {
    return async (dispatch) => {
      dispatch({ type: types.DELETE_NOTIFICATION_REQUEST });

      try {
        const headers = await getFetchHeaders();
        const response = await fetch(`${API_BASE}/${id}`, {
          method: 'DELETE',
          headers,
        });

        await getFetchResponseData(response);

        dispatch({
          type: types.DELETE_NOTIFICATION_SUCCESS,
        });
      } catch (err) {
        dispatch({
          type: types.DELETE_NOTIFICATION_FAILURE,
          error:
            err.message || 'Delete notification failed.',
        });
        throw err;
      }
    };
  },
};